import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  z-index: 999999999;
  max-width: 480px !important;
  margin: 0 auto;
`;
